import { FC } from 'react';
import { CustomerTaskCardBase } from './CustomerTaskCardBase';

interface InformationCardProps {
  type: string;
  message: string | undefined;
  headerText: string;
  date: string;
  title: string;
}

export const InformationCard: FC<InformationCardProps> = ({ type, message, headerText, date, title }: InformationCardProps) => {
  return (
    <CustomerTaskCardBase borderColor="blue" headerText={headerText} headerColor="blue" icon="info">
      <div className="text-sm font-bold text-gray-700">{type}</div>
      <div className="my-1 font-bold">{title}</div>
      <div className="text-base font-semibold w-full truncate">{message}</div>
      <div className="text-sm text-gray-700">{date}</div>
    </CustomerTaskCardBase>
  );
};
